import {
    GET_PROFILE_LOADING,
    GET_PROFILE_SUCCESS,
    GET_PROFILE_REJECT,
} from "../../actions/profile/getAll";

import {
    GET_PROFILE_ID_LOADING,
    GET_PROFILE_ID_SUCCESS,
    GET_PROFILE_ID_REJECT,
} from "../../actions/profile/getId";

import {
    GET_PERMISE_LOADING,
    GET_PERMISE_SUCCESS,
    GET_PERMISE_REJECT,
} from "../../actions/profile/getAllPermises";

import {
    POST_PROFILE_LOADING,
    POST_PROFILE_SUCCESS,
    POST_PROFILE_REJECT,
    POST_PROFILE_RESET,
} from "../../actions/profile/post";

import {
    POST_PERMISE_LOADING,
    POST_PERMISE_SUCCESS,
    POST_PERMISE_REJECT,
    POST_PERMISE_RESET,
} from "../../actions/profile/postPermise";

import {
    PUT_PERMISE_LOADING,
    PUT_PERMISE_SUCCESS,
    PUT_PERMISE_REJECT,
    PUT_PERMISE_RESET,
} from "../../actions/profile/putPermise";

const stateInit = {
    isLoading: false,
    isSuccess: false,
    isReject: false,
    error: {},
    data: [],
    detail: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    post: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    postPermise: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    putPermise: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    permises: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
}

const profileReducer = (state = stateInit, action) => {
    switch (action.type) {
        // ------------- GET ALL --------------------
        case GET_PROFILE_LOADING: return {
            ...state,
            isLoading: true,
            isSuccess: false,
            isReject: false,
            data: [],
            error: {},
        }
        case GET_PROFILE_SUCCESS: return {
            ...state,
            isLoading: false,
            isSuccess: true,
            isReject: false,
            error: {},
            ...action.payload,
        }
        case GET_PROFILE_REJECT: return {
            ...state,
            isLoading: false,
            isSuccess: false,
            isReject: true,
            data: [],
            error: action.payload?.response?.data
        }

        // ------------- GET ID ID --------------------
        case GET_PROFILE_ID_LOADING: return {
            ...state,
            detail: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case GET_PROFILE_ID_SUCCESS: return {
            ...state,
            detail: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_PROFILE_ID_REJECT: return {
            ...state,
            detail: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }

         // ------------- GET PERMISES--------------------
         case GET_PERMISE_LOADING: return {
            ...state,
            permises: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case GET_PERMISE_SUCCESS: return {
            ...state,
            permises: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_PERMISE_REJECT: return {
            ...state,
            permises: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }

        // ------------- POST --------------------
        case POST_PROFILE_LOADING: return {
            ...state,
            post: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case POST_PROFILE_SUCCESS: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case POST_PROFILE_REJECT: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case POST_PROFILE_RESET: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- POST PERMISE--------------------
        case POST_PERMISE_LOADING: return {
            ...state,
            postPermise: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case POST_PERMISE_SUCCESS: return {
            ...state,
            postPermise: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case POST_PERMISE_REJECT: return {
            ...state,
            postPermise: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case POST_PERMISE_RESET: return {
            ...state,
            postPermise: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        // ------------- PUT --------------------
        case PUT_PERMISE_LOADING: return {
            ...state,
            putPermise: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case PUT_PERMISE_SUCCESS: return {
            ...state,
            putPermise: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case PUT_PERMISE_REJECT: return {
            ...state,
            putPermise: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case PUT_PERMISE_RESET: return {
            ...state,
            putPermise: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        default: return state;
    }
}

export default profileReducer